import { ccc } from "../components/ccc";

const cccSvg = () => {
	const cccs = document.querySelectorAll(".ccc");
	cccs.forEach((el) => {
		el.innerHTML = ccc;
	});
};

export { cccSvg };
